import React from 'react'
import Text from "../../../../components/Text";
import Card from "../../../../components/Card";
import cx from 'classnames'
import styles from './CreateMediaCard.module.scss' ;
import {useTranslation} from "react-i18next";

const CreateMediaCard: React.FC<{openCreateModal: () => void}> = ({openCreateModal}) => {
    const { t } = useTranslation(['global'])
    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div className={cx(styles['card-inner-wrapper'])} onClick={() => openCreateModal()}>
                <div className={cx(styles['card-plus'])}>
                    +
                </div>
                <Text>{t("uploadMedia")}</Text>
            </div>
        </Card>
    )
}

export default CreateMediaCard
